<span>{{ cellTextContent }}</span>
<a
  xpo-regular-link
  class="ig-guidelinesCellRenderer-pointer"
  (click)="onShowMoreClicked()"
  *ngIf="isShowMoreLinkDisplayed"
  >Show more</a
>
